module.exports = __webpack_public_path__ + "static/media/notifications.e350ce93.svg";